export default __webpack_public_path__ + "static/media/social-fb.1687bac1.png";